var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { ProjectManager } from '../../components/Project';
import { Navigator } from '../../../ts/components/Navigator';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('home')) {
                this.setupWheelScroll();
                this.setupScrollEndCallback();
            }
            if (sessionStorage.getItem('targetProjectId')) {
                const targetProjectId = sessionStorage.getItem('targetProjectId');
                const targetSlideIndex = parseInt(sessionStorage.getItem('targetSlideIndex')) || 0;
                setTimeout(() => {
                    FrontPage.jumpTo(targetProjectId, targetSlideIndex);
                }, 150);
                sessionStorage.removeItem('targetProjectId');
                sessionStorage.removeItem('targetSlideIndex');
            }
            $(window).on('keydown', (event) => {
                if (!['ArrowUp', 'ArrowDown'].includes(event.key))
                    return;
                event.preventDefault();
                ;
                if (event.key === 'ArrowUp') {
                    if (FrontPage.projectIndex == 0)
                        return;
                    FrontPage.projectIndex--;
                }
                if (event.key === 'ArrowDown') {
                    if (FrontPage.projectIndex >= $('.project').length - 1)
                        return;
                    FrontPage.projectIndex++;
                }
                Navigator.navigate($('.project').eq(FrontPage.projectIndex).find('a').first().attr('href'), 'scroll', FrontPage.projectIndex);
            });
            $('.header-back-to-top').on('click', (event, link) => {
                if ($(window).width() >= 992 || !$('body').hasClass('home'))
                    return;
                event.preventDefault();
                Navigator.navigate('/', 'scroll', 0);
                $('main').get(0).scrollTo({ top: 0, behavior: 'smooth' });
            });
            ProjectManager.currentProjectId = parseInt($('.project').first().attr('id').replace('project-', ''));
            $('.logo-animation').on('click', () => {
                $('.logo-animation').remove();
            });
            const logoAnimationAlreadyPlayed = sessionStorage.getItem('logoAnimationPlayed');
            if (logoAnimationAlreadyPlayed === 'true')
                $('.logo-animation').remove();
            sessionStorage.setItem('logoAnimationPlayed', 'true');
            this.success();
        });
    }
    setupWheelScroll() {
        if (window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 992px)').matches) {
            window.addEventListener('wheel', (event) => {
                event.preventDefault();
                // Debounce to prevent multiple scrolls
                clearTimeout(this.scrollTimeout);
                this.scrollTimeout = window.setTimeout(() => {
                    FrontPage.isScrolling = false;
                }, 50);
                if (FrontPage.isScrolling || $('.btn-toggle-menu').hasClass('is-active'))
                    return;
                const deltaY = event.deltaY;
                if (Math.abs(deltaY) > 0) {
                    FrontPage.isScrolling = true;
                    // Determine direction
                    if (deltaY > 0 && FrontPage.projectIndex < $('.project').length - 1) {
                        FrontPage.projectIndex++;
                    }
                    else if (deltaY < 0 && FrontPage.projectIndex > 0) {
                        FrontPage.projectIndex--;
                    }
                    Navigator.navigate($('.project').eq(FrontPage.projectIndex).find('a').first().attr('href'), 'scroll', FrontPage.projectIndex);
                }
            }, { passive: false });
        }
        else {
            $('main').on('scroll', () => {
                if (FrontPage.isScrolling)
                    return;
                const scrollTop = $('main').get(0).scrollTop;
                const windowHeight = $(window).height();
                const newProjectIndex = Math.floor(scrollTop / windowHeight);
                if (newProjectIndex !== FrontPage.projectIndex) {
                    FrontPage.projectIndex = newProjectIndex;
                    const projectElement = $('.project').eq(FrontPage.projectIndex);
                    if (projectElement.length > 0) {
                        setTimeout(() => {
                            Navigator.navigate(projectElement.find('a').first().attr('href'), 'scroll', FrontPage.projectIndex);
                        }, 500);
                        FrontPage.isScrolling = false;
                    }
                }
            });
        }
    }
    setupScrollEndCallback() {
        if (FrontPage.disableScrollReset)
            return;
        let scrollTimeout;
        $('main').on('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = window.setTimeout(this.resetHorizontalScrolls, 150);
        });
        $(window).on('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = window.setTimeout(this.resetHorizontalScrolls, 150);
        });
    }
    resetHorizontalScrolls() {
        $('.slide-container').each(function (container) {
            container.get(0).scrollLeft = 0;
        });
    }
    static scrollTo(projectIndex, slideIndex, transition) {
        FrontPage.projectIndex = projectIndex;
        if (transition === undefined)
            transition = true;
        // Scroll to the selected project
        if (window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 992px)').matches) {
            $('html, body').get(0).scrollTo({
                top: FrontPage.projectIndex * $(window).height(),
                behavior: transition ? 'smooth' : 'instant'
            });
        }
        else {
            /* Do nothing on mobile, as system scroll is used
            FrontPage.isScrolling = true;
            $('main').get(0).scrollTo({
              top: FrontPage.projectIndex * $(window).height(),
              behavior: 'smooth'
            });
            */
        }
        ProjectManager.currentProjectId = parseInt($('.project').eq(FrontPage.projectIndex).attr('id').replace('project-', ''));
        // Scroll to the selected slide within the project
        if (!slideIndex)
            slideIndex = 0;
        setTimeout(() => {
            console.log('Jump to slide', slideIndex, 'of project', ProjectManager.currentProjectId);
            ProjectManager.projects[ProjectManager.currentProjectId].jumpTo(slideIndex, 'smooth');
        }, slideIndex === 0 ? 50 : 1000);
        $('.slide-caption').addClass('is-visible');
    }
    static jumpTo(projectId, slideIndex = 0) {
        ProjectManager.currentProjectId = parseInt(projectId);
        FrontPage.disableScrollReset = true;
        this.projectIndex = $('#project-' + projectId).index();
        $('html, body').get(0).scrollTo({
            top: FrontPage.projectIndex * $(window).height(),
            behavior: 'auto'
        });
        ProjectManager.projects[parseInt(projectId)].jumpTo(slideIndex);
        $('.slide-caption').addClass('is-visible');
        setTimeout(() => {
            FrontPage.disableScrollReset = false;
        }, 150);
    }
}
FrontPage.projectIndex = 0;
FrontPage.disableScrollReset = false;
FrontPage.isScrolling = false;
